export default __webpack_public_path__ + "eecb684eea07659cab97eb82da6ea996.svg";